import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICheckbox from 'UIComponents/input/UICheckbox';
import UIHelpIcon from 'UIComponents/icon/UIHelpIcon';

// @ts-expect-error ts-migrate(2565) FIXME: Property 'defaultProps' is used before being assig... Remove this comment to see the full error message
import { jsx as _jsx } from "react/jsx-runtime";
function CheckboxField(props) {
  return /*#__PURE__*/_jsx(UICheckbox, {
    checked: props.value,
    disabled: props.isDisabled,
    "data-test-id": "checkbox-test-id",
    onChange: ({
      target: {
        checked
      }
    }) => props.onCheckedChanged(checked),
    children: /*#__PURE__*/_jsx(UIHelpIcon, {
      "data-test-id": "help-icon-test-id",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.helpLangPath
      }),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: props.labelLangPath
      })
    })
  });
}
CheckboxField.propTypes = {
  helpLangPath: PropTypes.string,
  isDisabled: PropTypes.bool,
  labelLangPath: PropTypes.string.isRequired,
  onCheckedChanged: PropTypes.func.isRequired,
  value: PropTypes.bool.isRequired
};
CheckboxField.defaultProps = {
  isDisabled: false
};
export default CheckboxField;